module.exports = __webpack_public_path__ + "img/person-white.e2910b2e.svg";